import { addNewProjectConstants } from '../constant/addNewProject.constants';
import { addNewProject } from '../services/addNewProject.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getAddNewProjectList = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        addNewProject.list(data)
            .then(
                res => {
                    if(!res) return;
                    
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res.result));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
                        
                        case _errorCode.ClientNotPermission:
                            functionCommon.logout();
                            break;

                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(addNewProjectList) { 
        return { type: addNewProjectConstants.GET_SUCCESS, addNewProjectList }; 
    }
}
